import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextComponent from './TextComponent';
import Styles from './Text.styles';

const StyledText = styled(TextComponent)`${Styles.text}`;

/**
 * Text component class for web
 * @extends {React.PureComponent}
 * @example
 * <Text>Hello World</Text>
 * @since 0.0.1
 * @version 0.0.1
 */
class Text extends PureComponent {
  /**
   * Text props
   * @property {element|node} children - component children
   * @property {string} [className] - modifier prop
   * @property {boolean} [bold] - true if the font is bold
   * @property {number} [numberOfLines] - if equals 1, the font will display in one line
   * @property {function} [onPress] - onClick action
   * @property {boolean} [selectable = true] - if true, the text cannot be selected
   * @property {Object} [style] - modifier prop
   * @property {string} [type = 'div'] -the text element type, can be:
   * h1, h2, h3, h4, h5, h6, div, span and p
   * @property {string} [testID] - test id property for e2e
   */
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
    className: PropTypes.string,
    bold: PropTypes.bool,
    numberOfLines: PropTypes.number,
    onPress: PropTypes.func,
    selectable: PropTypes.bool,
    style: PropTypes.string,
    tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'span', 'p', 'em']),
  };

  /**
   * Text default props
   * @property {string} [fontName = 'roboto'] - font family
   * @property {boolean} [selectable = true] - if true, the text cannot be selected
   */
  static defaultProps = {
    className: '',
    selectable: true
  };

  static childContextTypes = {
    isInAParentText: PropTypes.bool
  };

  static contextTypes = {
    isInAParentText: PropTypes.bool
  };

  /**
   * Returns the font class name
   * @param {boolean} bold - true if the text is bold
   * @returns {string}
   */
  static getClassName(bold) {
    return bold ? 'cbx-bold' : 'cbx-regular';
  }

  /**
   * getChildContext method
   * @returns {boolean}
   */
  getChildContext() {
    return { isInAParentText: true };
  }

  /**
   * Renders the components
   * @returns {?JSX}
   */
  render() {
    const {
      props: {
        className,
        style,
        tag,
        children,
        selectable,
        numberOfLines,
        onPress,
        bold
      },
      context: { isInAParentText }
    } = this;

    if (!children) return null;

    const typeElement = isInAParentText ? tag || 'span' : tag || 'div';

    return (
      <StyledText
        className={`${this.constructor.getClassName(bold)} ${className}`}
        style={style}
        isInAParentText={isInAParentText}
        selectable={selectable}
        numberOfLines={numberOfLines}
        onClick={onPress}
        tag={typeElement}
      >
        {children}
      </StyledText>
    );
  }
}

export default Text;
